import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Partners } from './components/Partners';
import { About } from './components/About';
import { Agenda } from './components/Agenda';
import { Register } from './components/Register';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-forest font-sans text-cream" data-id="element-0" data-mp="3f8ez5k0brtu7">
      <Header data-id="element-1" data-mp="2rlowqhk2dx92" />
      <main data-id="element-2" data-mp="2rl6th0yziirn">
        <Hero data-id="element-3" data-mp="2riknv6vnmdc2" />
        <Partners data-id="element-4" data-mp="2mluboumz01vx" />
        <About data-id="element-5" data-mp="2mmcb204xiw82" />
        <Agenda data-id="element-6" data-mp="2mmvk0rclqa9y" />
        <Register data-id="element-7" data-mp="2mndryl8mmcxp" />
      </main>
      <Footer data-id="element-8" data-mp="2mjzplczyq3q9" />
    </div>;
}